import { useContext } from 'react'
import { CountriesContext } from '../context'
import type { CountriesContextValue } from '../types'

export const useCountries = (): CountriesContextValue => {
  return useContext(CountriesContext)
}
